export default __webpack_public_path__ + "static/media/partner-kingdom-x.66e4d18b.jpg";